<template>
  <div>
    <v-container>
      <v-row width="100%"><div class="text-caption pt-0"><strong>Attributes</strong></div><v-divider/></v-row>
        <v-row width="100%" class="pl-2">
          <InifiniteScrollChipGroup
            :allData = getAttrHeadersNumerical
            :selections="this.getSelectedWidget.instance_setting.data.filteredHeaders"
            @updatedSelection="updatedSelection"
          >
          </InifiniteScrollChipGroup>
          <MissingHeaderSelection
            :missingHeaders="missingHeaders"
            :removeMissingHeaders="removeMissingHeaders"
          />
        </v-row>
      <v-row width="100%"><div class="text-caption pt-4"><strong>User Inputs</strong></div><v-divider/></v-row>
      <v-row width="100%" class="pl-2">
        <v-switch
          v-model="getSelectedWidget.instance_setting.data.inputVisible"
          label="Value Inputs"
        />
      </v-row>
    </v-container>
  </div>
</template>

<script>
import ChipGroup from "../ui/ChipGroup.vue";
import * as icons from "@/utilities/EllipseIcons.js";
import MissingHeaderSelection from "../../components/ui/MissingHeaderSelection.vue";

import { storeToRefs } from 'pinia';
import {useDataGraphicsStore} from "@/store/DataGraphicsStore.js";
import InifiniteScrollChipGroup from "../ui/InifiniteScrollChipGroup.vue";

export default {
  setup() {
    return {icons}
  },
  components:{
    ChipGroup,MissingHeaderSelection, InifiniteScrollChipGroup
  },
  props:{
    getSelectedWidget:{}
  },
  data:()=>({
      data_headers: [],
      loaded: false,
      missingHeaders: [],
    }),
  setup() {
    const dataGraphicsStore = useDataGraphicsStore()
    const {
      getAttrHeaderNames,
      getAttrHeadersNumerical,
    } = storeToRefs(dataGraphicsStore)
    return {getAttrHeaderNames, getAttrHeadersNumerical}
  },
  created(){
  },
  mounted(){
    this.verifySelectedHeaders();
  },
  computed:{
  },
  watch: {
    'getSelectedWidget': {
      deep: true,
      immediate: true,
      handler: function() {
        this.verifySelectedHeaders();  
      }
    }
  },
  methods:{
    updatedSelection(selected){
        this.getSelectedWidget.instance_setting.data.filteredHeaders = selected;
      },
    verifySelectedHeaders() {
      if (this.getSelectedWidget.instance_setting.data) {
      let missingHeaders = [];

      const selectedAttributes = this.getSelectedWidget.instance_setting.data.filteredHeaders;
      for (let selectedAttribute of selectedAttributes) {
        if (!this.getAttrHeaderNames.includes(selectedAttribute)) {
        missingHeaders.push(selectedAttribute);
        }
      }
      this.missingHeaders = missingHeaders;
      }
    },
    removeMissingHeaders() {
      //remove each missing headers
      let filteredHeaders = this.getSelectedWidget.instance_setting.data.filteredHeaders.filter(
      (header) => !this.missingHeaders.includes(header)
      );
      this.getSelectedWidget.instance_setting.data.filteredHeaders = filteredHeaders;
      this.missingHeaders = [];
    }
  }
}
</script>